import { ToolProvider } from '@/backend/types'
import { claude37ThinkingTool } from '@/modules/Project/Tools/registry/claude37Thinking'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

export const claude37ThinkingVertexAiTool: ToolRegistryItem = {
  ...claude37ThinkingTool,
  provider: ToolProvider.vertex_ai_claude,
}
